<template>
    <div id="cesta">
      <div id="cerrar-cesta" @click="cerrar">
        <span class="tcon tcon-menu--xbutterfly tcon-transform">
            <span class="tcon-menu__lines" aria-hidden="true"></span>
        </span>
      </div>
      <h3 v-if="titulo" class="titulo-enc">{{ titulo }}</h3>
      <div v-if="!cestaVacia" class="cesta__lista-header is-hidden-mobile">
        <div></div>
        <div>Item</div>
        <div>Cantidad</div>
        <div>Precio</div>
      </div>
      <div v-if="!cestaVacia" class="cesta__lista">
        <ItemCarrito v-for="item in items" :key="item.clave" :clave="item.clave" :cantidad="item.cantidad" :precio="item.precio" :producto="item.producto" @eliminado="eliminarItem" @modificado="modificarItem"/>
      </div>
      <div v-if="cestaVacia" class="notification is-info" role="alert">Cesta vacía</div>
      <div v-if="!cestaVacia" class="total">
        Total: <strong>{{ total }}</strong>
      </div>
      <div v-if="!cestaVacia" class="btn-cesta">
        <div class="columns is-multiline">
          <div class="column is-4 is-offset-8">
            <div class="button is-rounded is-outlined btn-cesta-continuar" @click="cerrar">Sigue comprando</div>
          </div>
          <div v-if="esUsuario" class="column  is-4 is-offset-8">
            <a href="/checkout/datos" class="button is-rounded btn-finalizar">
              <span v-if="esEdicion">Editar pedido</span>
              <span v-else>Comprar ahora</span>
            </a>
          </div>
          <div v-else class="column is-4 is-offset-8">
            <div class="button is-rounded btn-finalizar btn-requerir-login" @click="requerirLogin">Comprar ahora</div>
          </div>
        </div>
      </div>
      <div v-if="!cestaVacia && retailrocketActivo" class="js-cesteable">
        <div class="lista columns is-multiline is-mobile">
          <div class="column is-12-mobile is-12-tablet is-12-desktop is-12-fullhd"
               data-retailrocket-markup-block="60b6333097a52521ace905ef" :data-product-id="idsProductos">
              <!-- Related items -->
          </div>
          <div class="column is-12-mobile is-12-tablet is-12-desktop is-12-fullhd"
               data-retailrocket-markup-block="60fe87c397a5251ff83469d6" :data-product-id="idsProductos">
            <!-- Related items -->
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* global $, retailrocket */
import ItemCarrito from "./ItemCarrito.vue";
import seguimiento from "../modulos/seguimiento"
import toastr from 'toastr';

export default {
  name: "Carrito",
  components: {ItemCarrito},
  data() {
    return {
      titulo: null,
      items: [],
      mensajes: [],
      total: 0,
      esUsuario: false,
      esEdicion: false,
      retailrocketActivo: false,

      overlay: null,
      cesta: null
    }
  },
  computed: {
    idsProductos() {
      // ids de los productos en la cesta separados por coma
      return this.items.map(item => item.producto.id).join(",");
    },
    cestaVacia() {
      return this.items.length === 0;
    }
  },
  mounted() {
    let vm = this;
    this.overlay = $('<div id="overlay-cesta"></div>');
    this.overlay.removeClass("visible");
    $('body').append(this.overlay);
    this.cesta = $("#cesta");
    window.onhashchange = this.locationHashChanged;
    $("#btn-menu-cesta").on("click", function (e) {
      e.preventDefault();
      vm.toggle();
    });
    this.overlay.on("click", function () {
      vm.cerrar();
    });
  },
  methods: {
    toggle() {
      if(this.cesta.hasClass("abierta")) {
        this.cerrar();
      } else {
        this.abrir();
      }
    },
    abrir() {
      this.obtenerDatos();
    },
    mostrarCarrito() {
      this.overlay.addClass("visible");
      this.cesta.addClass("abierta");
      $("html").addClass("carrito-abierto");
      location.hash = 'carrito';

      if (!this.retailrocketActivo) {
        return;
      }

      this.$nextTick(() => {
        try {
          retailrocket.markup.render();
        } catch (e) {
          console.log("-> retailrocket", e);
        }
      });
    },
    cerrar() {
      this.overlay.removeClass("visible");
      this.cesta.removeClass("abierta");
      $("html").removeClass("carrito-abierto");
      this.removeHash();
    },
    removeHash () {
      history.pushState("", document.title, window.location.pathname
          + window.location.search);
    },
    locationHashChanged() {
      if (location.hash === "") {
        this.cerrar();
      }
    },
    obtenerDatos() {
      let vm = this;
      $.ajax({
        url: "/cesta",
        dataType: "json",
        success: function (json) {
          vm.actualizarDatos(json);
          vm.mostrarCarrito();
        },
        error: function (jqXHR) {
          console.log('Error servidor', jqXHR.responseText);
        },
        beforeSend: function() {
          $("#cargador").show();
        },
        complete: function() {
          $("#cargador").hide();
        }
      });
    },
    actualizarDatos(json) {
      this.titulo = json.titulo;
      this.items = Object.values(json.items);
      this.mensajes = json.mensajes;
      this.total = json.total;
      this.esUsuario = json.esUsuario;
      this.esEdicion = json.esEdicion;
      this.retailrocketActivo = json.retailrocketActivo;

      for (let i = 0; i < this.mensajes.length; i++) {
        toastr.error(this.mensajes[i]);
      }
    },
    modificarItem(dato) {
      this.enviarSolicutud({
        accion: 'carrito-actualizar-item',
        dato: dato
      });
    },
    eliminarItem(clave) {
      this.enviarSolicutud({
        accion: 'carrito-borrar-item',
        clave: clave
      });
    },
    enviarSolicutud(datos) {
      let vm = this;
      $.ajax({
        url: "/cesta/acciones",
        type: "POST",
        data: datos,
        cache: false,
        success: function(json) {
          if (json.error) {
            vm.mensajes = json.mensajes;
            return;
          }
          vm.actualizarDatos(json);
          $("#cesta-nro").text(json.nro_items);
          if (datos.accion === "carrito-borrar-item") {
            seguimiento.borrar(json.seguimiento.id, json.seguimiento.categoria, json.seguimiento.marca, json.seguimiento.precio, json.seguimiento.nombre, json.seguimiento.cantidad);
          } else if (datos.accion === "carrito-actualizar-item") {
            seguimiento.actualizar(json.seguimiento.itemsAgregados, json.seguimiento.itemsQuitados)
          }
        },
        error: function (jqXHR) {
          console.log('Error servidor', jqXHR.responseText);
        },
        beforeSend: function() {
          $("#cargador").show();
        },
        complete: function() {
          $("#cargador").hide();
        }
      });
    },
    requerirLogin() {
      this.cerrar();
      $("#modal").on("abierta", function () {
        $("#login-mensaje").removeClass("hidden");
        $("#modal").off();
      });
      $(".btn-login:first").trigger("click");
      localStorage.setItem("requerir-checkout", "si");
    }
  }
}
</script>